export const V1_REQUEST_SEARCH_RESULTS = 'V1_REQUEST_SEARCH_RESULTS'

export default () => {
  return {
    type: V1_REQUEST_SEARCH_RESULTS,
  }
}
